export const getUserTokenName = (): string => {
    return window.location.hostname + '_accessToken'
}

export const getGuestTokenName = (): string => {
    return window.location.hostname + '_guestAccessToken'
}